export const ESTIMATE = "estimate";
export const SPECIFICATION = "specification";
export const OUT_OF_ESTIMATE = "out-of-estimate";
export const ADDITIONAL = "additional";
export const MIMS = "services";

export const TABS_IDS = [ESTIMATE, SPECIFICATION, OUT_OF_ESTIMATE, ADDITIONAL, MIMS];
